export const firebaseConfig = {
  apiKey: "AIzaSyCsPuww81jfBe_JWhkSQk27wGUn6mIUcIo",
  authDomain: "notes-147a3.firebaseapp.com",
  databaseURL: "https://notes-147a3-default-rtdb.firebaseio.com",
  projectId: "notes-147a3",
  storageBucket: "notes-147a3.appspot.com",
  messagingSenderId: "658050822110",
  appId: "1:658050822110:web:7102204bdb5e3bb68db74f"
};